// Function to initialize checkedStates on mount
export const initializeCheckedStates = (envCOAData, checked) => {
  const initialCheckedStates = {};
  Object.keys(envCOAData).slice(0, -1).forEach((key) => {
    const data = envCOAData[key];
    initialCheckedStates[key] = {};
    const setCheckboxState = (obj, parentKey = []) => {
      if (typeof obj === "object" && !Array.isArray(obj)) {
        Object.keys(obj).forEach((nestedKey) => {
          setCheckboxState(obj[nestedKey], [...parentKey, nestedKey]);
        });
      } else if (Array.isArray(obj)) {
        obj.forEach(() => {
          const keyString = [...parentKey].join("-");
          initialCheckedStates[key][keyString] = { checked, indeterminate: false }; // Initialize all checkboxes as true on mount
        });
      }
    };
    setCheckboxState(data);
  });
  return initialCheckedStates;
};

export const updateCheckedStatesForUUID = (uuidToCheck, activeButtonId, newCheckedStates, checked, envCOAData, setCheckedStates, updatedSamples) => {
  const checkUUIDInData = (dataObj, parentKey = []) => {
    Object.keys(dataObj).forEach((key) => {
      // Skip the activeButtonId key and 'samples' key
      if (key !== "samples" && key !== activeButtonId) {
        const currentKey = parentKey[1] ? [parentKey[1], key].join("-") : key;

        // If the value is an object, recursively check inside it
        if (typeof dataObj[key] === "object" && !Array.isArray(dataObj[key])) {
          checkUUIDInData(dataObj[key], [...parentKey, key]);
        } else if (Array.isArray(dataObj[key])) {
          const containsUUID = dataObj[key].includes(uuidToCheck);

          if (containsUUID) {
            // Check how many values are in updatedSamples
            const valuesInUpdatedSamples = dataObj[key].filter((uuid) => Object.prototype.hasOwnProperty.call(updatedSamples, uuid)).length;
            const totalValues = dataObj[key].length;

            let indeterminateState;
            if (valuesInUpdatedSamples === 0 || valuesInUpdatedSamples === totalValues) {
              indeterminateState = false;
            } else {
              indeterminateState = true;
            }
            // Update the checked state for this key
            newCheckedStates[parentKey[0]] = {
              ...newCheckedStates[parentKey[0]],
              [currentKey]: {
                checked, // Set checked state to false if UUID is found
                indeterminate: indeterminateState,
              },
            };
          }
        }
      }
    });
  };

  // Run the recursive check for all keys in envCOAData
  checkUUIDInData(envCOAData);

  // Set the updated checked states
  setCheckedStates(newCheckedStates);
};

export const allCheckedTrue = (states) => Object.values(states).every((category) => Object.values(category).every((item) => item.checked === true));
